<template>
    <div class="order">
        <div class="luck-btn flex_between"> 
            <div class="flex" style="align-items: center;">
                <p>订单计划表-</p>
                <p style="color:#409EFF;">截止{{endDate}}</p>
            </div>
            <div @click="getExcelData"><span>单位：辆/元</span></div>
            
        </div>
        <div id="luckysheet" ref="scrollview"
        @mousewheel="scrollChange" v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
        
        </div>
    </div>
</template>
<script>
import { firstHeader,border,carTypeItem,carTypeIndex } from '@/assets/js/order'
// import { getIndexArrOne,getRC,getIndexArrMonth} from '@/util/getTableData';
export default {
    props:{
        data:{
            type:Object,
            default:{}
        },
        sdate:{
            type:String,
            default:''
        },
        edate:{
            type:String,
            default:''
        },
        carType:{
            type:Array,
            default:[]
        }
    },
        
    
    data(){
        return{
            qcsList:0,
            edited:[],
            tableLength:0,
            tableData:this.data,
            date:[],
            endDate:'',
            mydata:[],
            loading:false,
            options: {},
        }
    },
    mounted(){
        let _this = this
        this.options = {
                container: 'luckysheet', //容器id名
                title: '订单计划表', // 表 头名
                lang: 'zh', // 中文
                showtoolbar: false, // 是否显示工具栏
                showinfobar: false, // 是否显示顶部信息栏
                showsheetbar:false,
                // showstatisticBar:false,
                enableAddRow:false,
                sheetFormulaBar:false,
                enableAddRow:false,
                enableAddBackTop:false,
                accuracy:0,
                cellRightClickConfig:{
                    
                    copy: false, // 复制
                    copyAs: false, // 复制为
                    paste: false, // 粘贴
                    insertRow: false, // 插入行
                    insertColumn: false, // 插入列
                    deleteRow: false, // 删除选中行
                    deleteColumn: false, // 删除选中列
                    deleteCell: false, // 删除单元格
                    hideRow: true, // 隐藏选中行和显示选中行
                    hideColumn: true, // 隐藏选中列和显示选中列
                    rowHeight: false, // 行高
                    columnWidth: false, // 列宽
                    clear: false, // 清除内容
                    matrix: false, // 矩阵操作选区
                    sort: false, // 排序选区
                    filter: false, // 筛选选区
                    chart: false, // 图表生成
                    image: false, // 插入图片
                    link: false, // 插入链接
                    data: false, // 数据验证0
	                cellFormat: false // 设置单元格格式
                },
                hook: {
                    cellUpdated: function (r, c, oldValue, newValue, isRefresh) {
                        if(isRefresh&&r>10){
                            if(_this.edited.length>0){
                                const has = _this.edited.filter(item=>item.r==r&&item.c==c)
                                if(has.length>0){
                                    _this.edited.forEach(item=>{
                                        if(item.r==r&&item.c==c){
                                            item.v = newValue.v
                                        }
                                    })
                                }else{
                                    _this.edited.push({r:r,c:c,v:newValue.v})
                                }
                            }else{
                                _this.edited.push({r:r,c:c,v:newValue.v})
                            }
                            _this.edited.forEach(item=>{
                                item.name = window.luckysheet.getCellValue(item.r,3)
                            })
                            _this.$emit('getEditData',_this.edited)
                            window.luckysheet.exitEditMode()
                           
                        }
                    }
                }
            }
        let arr = this.edate.split("-")
        this.endDate = arr[0]+'年'+arr[1]+'月'
        this.qcsList = 17+this.data.orderPlanTotalColumn.monthlyCapitalBalanceByMethodList.length+this.data.orderPlanTotalColumn.monthlyPayPlanByMethodList.length
        this.tableLength = this.qcsList+(this.carType.length*11)
       
        window.luckysheet.exitEditMode();
        window.luckysheet.destroy();
        this.getExcelDate()
        const scrollview = this.$refs['scrollview']
        scrollview.addEventListener('scroll', this.scrollChange, true)
    
       
    },
    methods:{
        scrollChange () {
            window.luckysheet.exitEditMode()
        },
        // 计算年月
        getExcelDate(){
          
            let sy= Number(this.sdate.split("-")[0]);
            let ey= Number(this.edate.split("-")[0]);

            let sm = Number(this.sdate.split("-")[1]);
            let em = Number(this.edate.split("-")[1]);

            let y ;
            let date = []
            if(sy==ey){//同一年
                if(em>sm){
                    for(let i=sm;i<=em;i++){
                        date.push(`${sy}年${i}月`)
                    }
                }else if(em==sm){
                    date.push(`${ey}年${em}月`)
                }else{
                    this.$DonMessage.error("结束日期必须在开始日期之后")
                }
            }else if(ey>sy){//不同年
                y = ey-sy
                if(y==1){// 没有间隔的一整年
                    for(let i=sm;i<=12;i++){
                        date.push(`${sy}年${i}月`)
                    }
                    for(let j=1;j<=em;j++){
                        date.push(`${ey}年${j}月`)
                    }
                }
                if(y>1){//中间有完整一整年
                    let fwy = sy+1
                    let lwy = ey-1
                    for(let i=sm;i<=12;i++){
                        date.push(`${sy}年${i}月`)
                    }
                    for(let year=fwy;year<=lwy;year++){
                        for(let month=1;month<=12;month++){
                            date.push(`${year}年${month}月`)
                        } 
                    }
                    for(let j=1;j<=em;j++){
                        date.push(`${ey}年${j}月`)
                    }
                }

            }else{
                this.$DonMessage.error("结束日期必须在开始日期之后")
            }
       
            this.date = date
            this.handleTest()
        },

  

        demo(){
           
            
            if(this.mydata[0].celldata.length>0){
                window.luckysheet.destroy();
                this.options.data = this.mydata;
                window.luckysheet.create(this.options);
                this.$store.state.excelLoading = false
                window.luckysheet.setDataVerification(//期初数编辑规则
                    {
                        type: 'number_integer',
                        type2: "bw",
                        value1: 0,
                        value2: 99999,
                        prohibitInput: true
                    },
                    {
                        range: `E${this.qcsList+1}:E${this.tableLength}`
                    }
                )
                window.luckysheet.setRangeShow({ row:[0], column:[0] }, {
                    show: false, // 选中状态不要高亮
                })
                // 遍历 合并板块序号项，不存在小数点则设置背景
                let bgArr = []
                let arr1 = this.data.orderPlanTotalEachMonthList[0].monthlyPayPlanByMethod
                let arr2 = this.data.orderPlanTotalEachMonthList[0].monthlyCapitalBalanceByMethod
                this.mydata[0].celldata.map(item=>{
                    
                    if(item.r>=1&&item.r<16+arr1.length+arr2.length&&item.c==2&&item.v.m.indexOf('.')==-1){
                        bgArr.push(`C${item.r+1}:EX${item.r+1}`)
                      
                    }
                })
                window.luckysheet.setRangeFormat("bg", '#eee', {range:[...bgArr]})
            }
        },
        handleTest(){
            // 期初数长度
            
            this.mydata = [
                {   
                    name: "这个是sheet1",
                    celldata: [],
                    frozen:{
                       type: 'rangeBoth',
                       range: {row_focus: 0, column_focus: 3}
                    },
                    config: {
                        authority:{// 当前工作表的权限配置
                            sheet: 1, // sheet表下标。
                            hintText: "这部分不可以进行修改", // 弹
                            allowRangeList: [
                                { sqref: `$E$${this.qcsList+1}:$E$${this.tableLength}`},//期初数
                            ]
                            
                        },
                        // borderInfo:[]
                        borderInfo: [...border],
                    },
                },
            ];
            
            // 初始第一行表头数据项
            firstHeader.map((item,index)=>{
                this.mydata[0].celldata.push(
                    {
                        r:0,
                        c:index,
                        v:{
                            bg:"#195c96",
                            bl: 1, 
                            v:item,
                            ht:0,
                            fc:'#fff'
                        },
                        
                    }
                )
            })
            // 年月数据
            if(this.date.length>0){
                this.date.map((item,index)=>{
                    this.mydata[0].celldata.push(
                        {
                            r:0,
                            c:index+6,
                            v:{
                                bg:"#195c96",
                                bl: 1, 
                                v:item,
                                ht:0,
                                fc:'#fff'
                            },

                        }
                    )
                })

            }
            // 添加合并项序号数据项
            let indexOne = ['1','1.1','1.2','1.3','2','3','4','5','6','7','7.1','7.2','8','9',
            '10'
            ]
            let leftHeader = [
                {
                    name:'订单计划',
                    ht:1
                },
                {
                    name:'◆在产',
                    ht:2
                },
                {
                    name:'◆在途',
                    ht:2
                },
                {
                    name:'◆到港',
                    ht:2
                },
                {
                    name:'销售计划',
                    ht:1
                },
                {
                    name:'终端库存',
                    ht:1
                },
                {
                    name:'销售收入',
                    ht:1
                },
                {
                    name:'销售利润',
                    ht:1
                },
                {
                    name:'销售利润率',
                    ht:1
                },
                {
                    name:'现金流量表',
                    ht:1
                },
                {
                    name:'现金流入小计',
                    ht:2
                },
                {
                    name:'现金流出小计',
                    ht:2
                },
                {
                    name:'当期净现金流量',
                    ht:1
                },{
                    name:'累计净现金流量',
                    ht:1
                },
                {
                    name:'付款计划',
                    ht:1
                }
            ]
            let arr1 = []
            let arr2 = []
            this.data.orderPlanTotalEachMonthList[0].monthlyPayPlanByMethod.map((data,i)=>{
                arr1.push({name:data.methodName,ht:1})
                arr2.push(`10.${i+1}`)
            })
            
            arr1.push({name:'资金余额',ht:1})
            arr2.push('11')
            // this.data.orderPlanTotalEachMonthList.map(item=>{
            this.data.orderPlanTotalEachMonthList[0].monthlyCapitalBalanceByMethod.map((data,i)=>{
                arr1.push({name:data.methodName,ht:1})
                arr2.push(`11.${i+1}`)
            })
            indexOne.push(...arr2)
            
            indexOne.map((item,index)=>{
                    if(item.indexOf('.')==-1){
                        this.mydata[0].celldata.push(
                            {
                                r:index+1,
                                c:2,
                                v:item,
                                v:{
                                    bg:'#eee',
                                    bl: 1, 
                                    v:item,
                                    ht:0,
                                    ct: {
                                        "fa": "@",
                                        "t": "s"
                                    },
                                },
                            }
                        )
                        
                    }else{

                        this.mydata[0].celldata.push(
                            {
                                r:index+1,
                                c:2, 
                                v:{ 
                                    v:item,
                                    ht:2,
                                    ct: {
                                        "fa": "@",
                                        "t": "s"
                                    },
                                },
                            }
                        )
                    }
            })
            leftHeader.push(...arr1)
            // 添加销量项目名
            leftHeader.map((item,index)=>{
                this.mydata[0].celldata.push(
                    {
                        r:index+1,
                        c:3,
                        v:{ 
                            v:item.name,
                            ht:item.ht
                        },
                    }
                )
            })
            
            // 根据车型动态添加相关序号和项目名称以及合并项
            // 合并项：合计/车型/空白处
            let mc = [
                {
                    "r": 1,
                    "c": 0,
                    "v": {
                        "v":'/',
                        "bl": 1, 
                        'ht':0,
                    },
                    "mc": {      
                        "r": 1,  
                        "c": 0,  
                        "rs": leftHeader.length, 
                        "cs": 1  
                    },

                }, 
                {
                    "r": 1,
                    "c": 1,
                    "v": {
                        "v":'合计',
                        'ht':0,
                        "bl": 1, 
                    },
                    "mc": {       
                        "r": 1,   
                        "c": 1,   
                        "rs": leftHeader.length, 
                        "cs": 1   
                    },

                },
            ]
            let merge = {
                "1_0": {
                    "r": 1,
                    "c": 0,
                    "rs": leftHeader.length,
                    "cs": 1
                },
                "1_1": {
                    "r": 1,
                    "c": 1,
                    "rs": leftHeader.length,
                    "cs": 1
                },
            }
            let brr = []//车型项目名
            let crr = []//车型序号
            let borderArr = []//边框数据
            borderArr.push({
                    "rangeType": "range",
                    "borderType": "border-all",
                    "style": "3",
                    "color": "#a4a4a4",
                    "range": [{
                        "row": [0, leftHeader.length+(this.carType.length*11)],
                        "column": [0, firstHeader.length+this.date.length-1]
                    }]
                },)
            if(this.carType.length!=0){
                this.carType.map((item,i)=>{
                brr.push(...carTypeItem)
                crr.push(...carTypeIndex)
                mc.push({
                    "r": leftHeader.length+1+(i*11),
                    "c": 0,
                    "v": {
                        "v":item.carModelName,
                        'ht':0,
                    },
                    "mc": {       
                        "r": leftHeader.length+1+(i*11),   
                        "c": 0,   
                        "rs": 11, 
                        "cs": 1   
                    },
                },
                {
                    
                    "r": leftHeader.length+1+(i*11),
                    "c": 1,
                    "v": {
                        "v":'',
                        'ht':0,
                    },
                    "mc": {       
                        "r": leftHeader.length+1+(i*11),   
                        "c": 1,   
                        "rs": 11, 
                        "cs": 1   
                    },

                
                })
                merge[`${leftHeader.length+1+(i*11)}_0`] = { 
                    "r": leftHeader.length+1+(i*11),
                    "c": 0,
                    "rs": 11,
                    "cs": 1
                 }
                 merge[`${leftHeader.length+1+(i*11)}_1`] = { 
                    "r": leftHeader.length+1+(i*11),
                    "c": 1,
                    "rs": 11,
                    "cs": 1
                 }
                 borderArr.push(
                    {
                    "rangeType": "range",
                    "borderType": "border-bottom",
                    "style": "8",
                    "color": "#77b8f9",
                    "range": [{
                        "row": [0, leftHeader.length+(i*11)],
                        "column": [0, firstHeader.length+this.date.length-1]
                    }]
                })

            })
            }

            this.mydata[0].config.borderInfo = [...borderArr]
            // 车型合并项
            this.mydata[0].celldata.push(...mc)
            // 合并配置
            this.mydata[0].config.merge = merge
            if(brr.length!=0){
               
                brr.map((item,index)=>{
                    this.mydata[0].celldata.push(
                        {
                            r:leftHeader.length+1+index,
                            c:3,
                            v:{ 
                                v:item.name,
                                ht:item.ht
                            },
                        }
                    )
                })
            }
            if(crr.length!=0){
               
                crr.map((item,index)=>{
                    if(item.indexOf('.')==-1){
                        this.mydata[0].celldata.push(
                            {
                                r:leftHeader.length+1+index,
                                c:2,
                                v:{ 
                                    v:item,
                                    ht:0
                                },
                            }
                        )
                    }else{
                        this.mydata[0].celldata.push(
                            {
                                r:leftHeader.length+1+index,
                                c:2,
                                v:{ 
                                    v:item,
                                    ht:2
                                },
                            }
                        )
                    }

                })
            }

            
            this.fillPosition()
            // this.demo()
            
        },
        fillPosition(){
            let array = this.mydata[0].celldata
            array.map(a=>{
                if(this.tableData.orderPlanTableEachCarModelList.length!=0){
                   
                    this.tableData.orderPlanTableEachCarModelList.map((item,i)=>{
                        if(a.v.v==item.carModelName){
                            item.r = a.r
                        }
                        item.planCountResultList.map(b=>{//订单计划
                            if(a.v.v==this.getExcelData(b.eachMonthLocalDate)){
                                b.c = a.c
                            }
                        })

                        item.inProductionCountResultList.map(b=>{//在产
                            if(a.v.v==this.getExcelData(b.eachMonthLocalDate)){
                                b.c = a.c
                            }
                        })
                        item.inTransitCountResultList.map(b=>{//在途
                            if(a.v.v==this.getExcelData(b.eachMonthLocalDate)){
                                b.c = a.c
                            }
                        })
                        item.arrivedAtPortCountResultList.map(b=>{//到岗
                            if(a.v.v==this.getExcelData(b.eachMonthLocalDate)){
                                b.c = a.c
                            }
                        })
                        item.salesPlanCountResultList.map(b=>{//销售计划
                            if(a.v.v==this.getExcelData(b.eachMonthLocalDate)){
                                b.c = a.c
                            }
                        })
                        item.paymentTypeList.map(b=>{
                            if(a.v.v==this.getExcelData(b.eachMonthLocalDate)){
                                b.c = a.c
                            }
                        })
                        // 销售收入
                    
                

                    
                    })
                }

                this.tableData.orderPlanTotalEachMonthList.map(item=>{
                    if(a.v.v==this.getExcelData(item.month)){
                            item.c = a.c
                        }
                })

                
            })
            
           
            this.fillData()
        },
        fillData(){
            if(this.tableData.orderPlanTableEachCarModelList.length!=0){
           
                this.tableData.orderPlanTableEachCarModelList.map(item=>{
                    item.planCountResultList.map(data=>{//订单计划
                        this.mydata[0].celldata.push(
                            {
                                r:item.r,
                                c:data.c,
                                v:{ 
                                    v:data.orderPlanCount,
                                    ht:0
                                },
                            }
                        )
                    })
                    item.inProductionCountResultList.map(data=>{//在产
                        this.mydata[0].celldata.push(
                            {
                                r:item.r+1,
                                c:data.c,
                                v:{ 
                                    v:data.inProductionCount,
                                    ht:0
                                },
                            }
                        )
                    })
                    item.inTransitCountResultList.map(data=>{//在涂
                        this.mydata[0].celldata.push(
                            {
                                r:item.r+2,
                                c:data.c,
                                v:{ 
                                    v:data.inTransitCount,
                                    ht:0
                                },
                            }
                        )
                    })
                    item.arrivedAtPortCountResultList.map(data=>{//到岗
                        this.mydata[0].celldata.push(
                            {
                                r:item.r+3,
                                c:data.c,
                                v:{ 
                                    v:data.inArrivedAtPortCount,
                                    ht:0
                                },
                            }
                        )
                    })
                    item.salesPlanCountResultList.map(data=>{//销售计划
                        this.mydata[0].celldata.push(
                            {
                                r:item.r+5,
                                c:data.c,
                                v:{ 
                                    v:data.salesPlanCount,
                                    ht:0
                                },
                            }
                        )
                    })
                    item.paymentTypeList.map(data=>{//付款类型
                        this.mydata[0].celldata.push(
                            {
                                r:item.r+7,
                                c:data.c,
                                v:{ 
                                    v:data.paymentName,
                                    ht:0
                                },
                            }
                        )
                    })
                    this.mydata[0].celldata.push(
                            {//期初数
                                r:item.r+6,
                                c:4,
                                v:{ 
                                    v:item.openingBalance, 
                                    ht:0
                                },
                            },
                            {//期初数订单计划
                                r:item.r,
                                c:4,
                                v:{ 
                                    v:item.openingBalanceOrderPlan, 
                                    ht:0
                                },
                            },
                            {//期初数 销售计划
                                r:item.r+5,
                                c:4,
                                v:{ 
                                    v:item.openingBalanceSalesPlan, 
                                    ht:0
                                },
                            },
                            {
                                r:item.r+6,
                                c:6,
                                v:{ 
                                    v:item.terminalInventoryFirstMonthCount, //终端库存首月
                                    ht:0
                                },
                            },
                            {
                                r:item.r+0,
                                c:5,
                                v:{ 
                                    v:item.planCountTotal, 
                                    ht:0
                                },
                            },
                            {
                                r:item.r+1,
                                c:5,
                                v:{ 
                                    v:item.inProductionCountTotal, 
                                    ht:0
                                },
                            },
                            {
                                r:item.r+2,
                                c:5,
                                v:{ 
                                    v:item.inTransitCountTotal, 
                                    ht:0
                                },
                            },
                            {
                                r:item.r+3,
                                c:5,
                                v:{ 
                                    v:item.arrivedAtPortCountTotal, 
                                    ht:0
                                },
                            },
                            // {
                            //     r:item.r+4,
                            //     c:5,
                            //     v:{ 
                            //         v:item.arrivedAtPortCountTotal, 
                            //         ht:0
                            //     },
                            // },
                            {
                                r:item.r+5,
                                c:5,
                                v:{ 
                                    v:item.salesPlanCountTotal, 
                                    ht:0
                                },
                            },
                            {
                                r:item.r+6,
                                c:5,
                                v:{ 
                                    v:item.terminalInventoryTotal, 
                                    ht:0
                                },
                            },
                            {
                                r:item.r+8,
                                c:5,
                                v:{ 
                                    v:item.salesRevenueTotal, 
                                    ht:0
                                },
                            },
                            {
                                r:item.r+9,
                                c:5,
                                v:{ 
                                    v:item.salesProfitTotal, 
                                    ht:0
                                },
                            },
                            {
                                r:item.r+10,
                                c:5,
                                v:{ 
                                    v:item.salesMarginTotal+'%', 
                                    ht:0
                                },
                            },

                    )
                    item.terminalInventoryOtherMonthCountList.map((data,i)=>{//终端库存
               
                        this.mydata[0].celldata.push(
                            {
                                r:item.r+6,
                                c:i+7,
                                v:{ 
                                    v:data,
                                    ht:0
                                },
                            }
                        )
                    })
                    //销售收入
                    item.salesRevenue.map((data,i)=>{
                        this.mydata[0].celldata.push(
                            {
                                r:item.r+8,
                                c:i+6,
                                v:{ 
                                    v:data,
                                    ht:0
                                },
                            }
                        )
                    })
                    //销售利润
                    item.salesProfit.map((data,i)=>{
                        this.mydata[0].celldata.push(
                            {
                                r:item.r+9,
                                c:i+6,
                                v:{ 
                                    v:data,
                                    ht:0
                                },
                            }
                        )
                    })
                    //销售利润
                    item.salesMargin.map((data,i)=>{
                        this.mydata[0].celldata.push(
                            {
                                r:item.r+10,
                                c:i+6,
                                v:{ 
                                    v:data+'%',
                                    ht:0
                                },
                            }
                        )
                    })
                })
            }

            let obj = this.data.orderPlanTotalColumn
            // 合计的合计项
            this.mydata[0].celldata.push(
                    {
                        r:1,
                        c:5,
                        v:{ 
                            v:obj.totalPlanCountSum,
                            ht:0
                        },
                    },
                    {
                        r:2,
                        c:5,
                        v:{ 
                            v:obj.totalInProductionCountSum,
                            ht:0
                        },
                    },
                    {
                        r:3,
                        c:5,
                        v:{ 
                            v:obj.totalInTransitCountSum,
                            ht:0
                        },
                    },
                    {
                        r:4,
                        c:5,
                        v:{ 
                            v:obj.totalArrivedAtPortCountSum,
                            ht:0
                        },
                        
                    },
                    {
                        r:5,
                        c:5,
                        v:{ 
                            v:obj.totalSalesPlanCountSum,
                            ht:0
                        },
                        
                    },
                    {
                        r:6,
                        c:5,
                        v:{ 
                            v:obj.totalTerminalInventoryCountSum,
                            ht:0
                        },
                        
                    },
                    {
                        r:7,
                        c:5,
                        v:{ 
                            v:obj.totalSalesRevenueSum,
                            ht:0
                        },
                        
                    },
                    {
                        r:8,
                        c:5,
                        v:{ 
                            v:obj.totalSalesProfitSum,
                            ht:0
                        },
                        
                    },
                    {
                        r:9,
                        c:5,
                        v:{ 
                            v:obj.totalSalesMarginSum+'%',
                            ht:0
                        },
                        
                    },
                    {
                        r:11,
                        c:5,
                        v:{ 
                            v:obj.cashInflowSubtotalSum,
                            ht:0
                        },
                        
                    },
                    {
                        r:12,
                        c:5,
                        v:{ 
                            v:obj.cashOutflowSubtotalSum,
                            ht:0
                        },
                        
                    },
                    {
                        r:13,
                        c:5,
                        v:{ 
                            v:obj.currentNetCashFlowSum,
                            ht:0
                        },
                        
                    },
                    {
                        r:14,
                        c:5,
                        v:{ 
                            v:obj.totalNetCashFlowSum,
                            ht:0
                        },
                        
                    },
                    {
                        r:15,
                        c:5,
                        v:{ 
                            v:obj.totalPaymentPlanCountSum,
                            ht:0
                        },
                        
                    },
                    {
                        r:16+obj.monthlyPayPlanByMethodList.length,
                        c:5,
                        v:{ 
                            v:obj.totalCapitalBalanceSum,
                            ht:0
                        },
                        
                    },

            )
            obj.monthlyPayPlanByMethodList.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:16+i,
                        c:5,
                        v:{ 
                            v:item.value,
                            ht:0
                        },
                    },
                )
            })
            obj.monthlyCapitalBalanceByMethodList.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:17+i+obj.monthlyPayPlanByMethodList.length,
                        c:5,
                        v:{ 
                            v:item.value,
                            ht:0
                        },
                    },
                )
            })
            this.tableData.orderPlanTotalEachMonthList.map((item,i)=>{
                this.mydata[0].celldata.push(
                    {
                        r:1,
                        c:item.c,
                        v:{ 
                            v:item.totalPlanCount,
                            ht:0
                        },
                    },
                    {
                        r:2,
                        c:item.c,
                        v:{ 
                            v:item.totalInProductionCount,
                            ht:0
                        },
                    },
                    {
                        r:3,
                        c:item.c,
                        v:{ 
                            v:item.totalInTransitCount,
                            ht:0
                        },
                    },
                    {
                        r:4,
                        c:item.c,
                        v:{ 
                            v:item.totalArrivedAtPortCount,
                            ht:0
                        },
                    },
                    {
                        r:5,
                        c:item.c,
                        v:{ 
                            v:item.totalSalesPlanCount,
                            ht:0
                        },
                    },
                    {
                        r:6,
                        c:item.c,
                        v:{ 
                            v:item.totalTerminalInventoryCount,
                            ht:0
                        },
                    },
                    {
                        r:7,
                        c:item.c,
                        v:{ 
                            v:item.totalSalesRevenue,
                            ht:0
                        },
                    },
                    {
                        r:8,
                        c:item.c,
                        v:{ 
                            v:item.totalSalesProfit,
                            ht:0
                        },
                    },
                    {
                        r:9,
                        c:item.c,
                        v:{ 
                            v:item.totalSalesMargin+'%',
                            ht:0
                        },
                    },
                    {
                        r:11,
                        c:item.c,
                        v:{ 
                            v:item.totalCashIn,
                            ht:0
                        },
                    },
                    {
                        r:12,
                        c:item.c,
                        v:{ 
                            v:item.totalCashOut,
                            ht:0
                        },
                    },  
                    {
                        r:13,
                        c:item.c,
                        v:{ 
                            v:item.totalCurrentNetCashFlow,
                            ht:0
                        },
                    },
                    {
                        r:14,
                        c:item.c,
                        v:{ 
                            v:item.totalTotalNetCashFlow,
                            ht:0
                        },
                    },
                    {
                        r:15,
                        c:item.c,
                        v:{ 
                            v:item.totalPaymentPlanCount,
                            ht:0
                        },
                    },
                    {
                        r:16+item.monthlyPayPlanByMethod.length,
                        c:item.c,
                        v:{ 
                            v:item.totalCapitalBalance,
                            ht:0
                        },
                    },
                )
                item.monthlyPayPlanByMethod.map((data,j)=>{
                    this.mydata[0].celldata.push(
                        {
                            r:16+j,
                            c:item.c,
                            v:{ 
                                v:data.value,
                                ht:0
                            },
                        },
                    )
                })
                item.monthlyCapitalBalanceByMethod.map((data,j)=>{
                    this.mydata[0].celldata.push(
                        {
                            r:17+j+item.monthlyPayPlanByMethod.length,
                            c:item.c,
                            v:{ 
                                v:data.value,
                                ht:0
                            },
                        },
                    )
                })
            })
           
            this.demo()

        },
        getExcelData(str){
            let arr = str.substr(0,7).split("-")
            let date;
            if(arr[1].substr(0,1)==0){
                date = arr[0]+'年'+arr[1].substr(1,2)+'月'
            }else{
                date = arr[0]+'年'+arr[1]+'月'
            }
            return date

        },
        
        getSingleDate(str){
    
            let date = ''
            let arr = str.substr(0,str.length-1).replace(/[\u4e00-\u9fa5]/g, "-").split("-")
         
            if(arr[1].length==1){
                arr[1] = '0'+arr[1]
            }
            date = arr[0]+'-'+arr[1]
            return date
        },
    },

    beforeDestroy(){
        window.luckysheet.exitEditMode();
        window.luckysheet.destroy();
        const scrollview = this.$refs['scrollview']
        // 移除监听
        scrollview.removeEventListener('scroll', this.scrollChange, true)
    },
}
</script>
<style lang="scss" scoped>
.order{
    min-height:calc(100vh - 100px);
    overflow: hidden;
    // background: pink;
    position: relative;
    #luckysheet{
        margin:0px;
        padding:0px;
        position:absolute;
        width:98%;
        box-sizing: border-box;
        left: 0px;
        top: 82px;
        bottom:0px;
        height: 88%;
    }
    .luck-btn{
        width: 100%;
        background: #ffffff;
        
        padding: 6px;
        box-sizing: border-box;
        margin-top: 50px;
        // align-items: center;
        p{
            font-size: 14px;
            color: #333;
            font-weight: bold;
            margin-right: 10px;
        }
        span{
            font-size: 12px;
            
        }
    }

}
</style>